import React from "react";
import { useQuery } from "@tanstack/react-query";
import PageHero from "@/components/PageHero";
import { IMG } from "@/lib/content";
import { useLang } from "@/lib/i18n";
import { Backdrop } from "@/components/IntersectMotif";
import RichText from "@/components/RichText";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";
import { LEGAL_DEFAULTS } from "@/lib/legalDefaults";

const PATHS = { privacy: "/privacy", terms: "/terms", cookies: "/cookies" };

export default function Legal({ type }) {
  const { isAr } = useLang();
  const key = LEGAL_DEFAULTS[type] ? type : "privacy";
  const def = LEGAL_DEFAULTS[key];

  const { data: legal = {} } = useQuery({ queryKey: ["legal"], queryFn: () => api.get("/legal").then((r) => r.data) });
  const doc = legal[key] || {};
  const title = isAr ? def.title_ar : def.title_en;
  const body = (isAr ? doc.body_ar : doc.body_en) || (isAr ? def.body_ar : def.body_en);

  return (
    <>
      <Seo title={`${title} — Intersect Holding`} description={def.title_en} path={PATHS[key]} lang={isAr ? "ar" : "en"} />
      <PageHero eyebrow={isAr ? "قانوني" : "Legal"} title={title} image={IMG.geometric} />
      <section className="section-pad relative overflow-hidden">
        <Backdrop src={IMG.riyadhNight} opacity={0.1} />
        <div className="max-w-[820px] mx-auto px-6 relative z-10">
          <RichText html={body} className="text-base text-soft-stone" data-testid="legal-content" />
        </div>
      </section>
    </>
  );
}
